
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { isDocPage, version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import DocMenuConfig from "@/core/config/DocMenuConfig";

import MainMenuConfig from "@/core/config/MainMenuConfig";
import MainMenuConfig_BIBO from "@/core/config/MainMenuConfig_BIBO";
import MainMenuConfig_ECC from "@/core/config/MainMenuConfig_ECC";
import MainMenuConfig_PCP from "@/core/config/MainMenuConfig_PCP";



import {vCheckOverride}  from "@/api/override";
import {getAvailablePCPForRepositionCount}  from "@/api/pcp";
import { getCurrentUser } from '../../utils/index';
import { isSitesBuilderPreviewUser } from '@/utils/sitesBuilderPreview';
import {
  formatUnreadBadge,
  subscribeInboxUnread
} from '@/utils/inboxUnreadHub.js';
//import {getUserCountryCode} from '@/api/dashboard';

export default defineComponent({
  name: "kt-menu",
  components: {},
  methods: {
    async checkIfHasOverrideAccess(){ 
      const response = await vCheckOverride();
      this.override = response.data.override;
    },
    async getAvailablePCPForRepositionCountFN(){ 
      const response = await getAvailablePCPForRepositionCount();
      this.repositionCount = response.data.repositionCount;

    },

  async getUserCcode(){ 
      //const response = await getUserCountryCode();
      //this.ccode = response.data.ccode;
      this.ccode = Number(localStorage.getItem("ccode"));
    },  

    isGroupActive(menuItem: any): boolean {
      if (!menuItem || !menuItem.sub) {
        return false;
      }
      const path = this.$route.path;
      return menuItem.sub.some((child: any) => {
        if (!child.route) {
          return false;
        }
        const base = child.route.replace(/\/$/, "");
        return path === base || path.startsWith(base + "/");
      });
    }

  },
  computed: {
    rawMenu(): any {
      if (this.pt === "bibo") return MainMenuConfig_BIBO;
      if (this.pt === "ecc") return MainMenuConfig_ECC;
      if (this.pt === "pcp") return MainMenuConfig_PCP;
      return MainMenuConfig;
    },
    visibleMenu(): any {
      const meetsCondition = (item: any): boolean => {
        if (!item.condition) {
          return true;
        }
        switch (item.condition) {
          case "autopma":
            return this.isShowAutoPMA === "true";
          case "notBibo":
            return this.packagetype !== "BIBO";
          case "ccode0":
            return this.ccode === 0;
          case "pcp":
            return this.isShowPCPMenu === "true";
          case "ustrip":
            return this.isShowUSTrip === "true";
          case "sitesPreview":
            return this.isSitesBuilderPreviewUser;
          case "override":
            return this.override === true;
          default:
            return true;
        }
      };

      const applyBadge = (item: any): any => {
        if (item.badge === "reposition") {
          return {
            ...item,
            badge: this.repositionCount > 0 ? this.repositionCount : null
          };
        }
        if (item.badge === "inboxUnread") {
          return {
            ...item,
            badge: formatUnreadBadge(this.inboxUnreadTotal)
          };
        }
        return item;
      };

      return (this.rawMenu as any[])
        .map((section: any) => {
          const pages = (section.pages || [])
            .filter(meetsCondition)
            .map((page: any) => {
              if (page.sub) {
                const sub = page.sub.filter(meetsCondition).map(applyBadge);
                return { ...page, sub };
              }
              return applyBadge(page);
            })
            .filter((page: any) => !page.sub || page.sub.length > 0);
          return { ...section, pages };
        })
        .filter((section: any) => section.pages.length > 0);
    },
    isSitesBuilderPreviewUser(): boolean {
      return isSitesBuilderPreviewUser();
    }
  },
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = text => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = match => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      isDocPage,
      DocMenuConfig,
      MainMenuConfig,
      MainMenuConfig_BIBO,
      MainMenuConfig_ECC,
      MainMenuConfig_PCP,
      asideMenuIcons,
      version,
      translate
    };
  },
  data() {
    return {
        current_usid: "" as string,
        override : false as boolean,
        isBiboOnly : "" as string,
        isShowAutoPMA : "" as string,
        isShowBibo: "" as string,
        pt : "" as string,
        packagetype : "" as string,
        ccode : -1 as number,
        isShowUSTrip : "" as string,
        isShowPCPMenu : "" as string,
        repositionCount : 0 as number,
        inboxUnreadTotal: 0 as number,
        unsubscribeInboxUnread: null as (() => void) | null
    }
  },
  beforeUnmount() {
    if (this.unsubscribeInboxUnread) {
      this.unsubscribeInboxUnread();
      this.unsubscribeInboxUnread = null;
    }
  },
  mounted() {
    let user = getCurrentUser(); 
    
    if(user !== undefined){
        this.current_usid = user.usid ;
        this.isBiboOnly = String(localStorage.getItem("bibo-only"));
        this.isShowAutoPMA = String(localStorage.getItem("sXhYoZwAABuCtDoEPFMGA")); 
        this.isShowBibo = String(localStorage.getItem("oZwAuCtDoAYBEPsXhFMGA"));  
        this.pt = String(localStorage.getItem("pt"));
        this.packagetype = String(localStorage.getItem("pVaAcNkPaOgGeItRyEpAeL"));
        this.isShowUSTrip = String(localStorage.getItem("sXhYoZwAuBsCtDrEiFp"));
        this.isShowPCPMenu = String(localStorage.getItem("sVhAoNwPPOCGPIM1e2n3u"));
    }

    this.ccode = Number(localStorage.getItem("ccode"));
    

    this.checkIfHasOverrideAccess();
    this.getAvailablePCPForRepositionCountFN();
    this.unsubscribeInboxUnread = subscribeInboxUnread((total) => {
      this.inboxUnreadTotal = total;
    });
  }

});
